import cookiesStorageSource from './storageSources/cookiesStorageSource';
import defaultStorageSource from './storageSources/defaultStorageSource';
import localStorageStorageSource from './storageSources/localStorageStorageSource';

class StorageService {
    constructor() {
        this.storageSourceName = '';
        this.buildStorageSource();
    }

    buildStorageSource() {
        try {
            if (window.localStorage) {
                this.storageSource = localStorageStorageSource;
                this.storageSourceName = this.storageSource.name;
                return;
            }

            document.cookie = 'test45245=testString';
            if (document.cookie) {
                this.storageSource = cookiesStorageSource;
                this.storageSourceName = this.storageSource.name;
                return;
            }
        } catch (error) {
            //todo add logger service
        }

        this.storageSource = defaultStorageSource;
        this.storageSourceName = this.storageSource.name;
    }

    get(vname) {
        return this.storageSource.get(vname);
    }

    add(vname, value) {
        this.storageSource.add(vname, value);
    }

    delete(vname) {
        this.storageSource.delete(vname);
    }

    clear() {
        this.storageSource.clear();
    }
}

export default new StorageService();
